export const manageRequestConst = {
    requestTypesApiUrl: "/request-types",
    divisionsApiUrl: "/divisions",
    searchRequestApiUrl: "/request/search",
    requestDetails: "/request-details/",
    requestHistory: "/request-history/",
    requestForward: "/request/forward",
    requestCancel: "/request/cancel",
    requestClose: "/request/close",
    requestReady: "/request/ready",
    returnRequest: "/request/return",
    requestSendToJde: "/request/send-to-jde",
    pendingRequests: "/request/pending/",
    reviewedRequests: "/request/reviewed/",
    bankAccount: "/bank-account/",
    sendToBank: "/request/send-to-bank",
    validateBankRequest: "/request/send-to-bank/validate",
    requestApprove: "/request/approve",
    paymentFile: "/produce-payment-file",
    openRequests: "/request/open/",
    attachments: "/attachments/",
}